import styled, { keyframes } from 'styled-components';

export const ContainerBell = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  cursor: pointer;

  & > button {
    border-radius: 50%;
    padding: 8px;
    background-color: rgb(102, 102, 102);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  }
`;

export const ContainerDoneAllIcon = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  margin-bottom: 15px;
  color: #757575;
  cursor: pointer;

  :hover {
    opacity: 50%;
  }
`;

export const ContainerNotifications = styled('div')`
  display: flex;
  width: 500px;
  padding: 16px 24px 0px 24px;
  max-height: 600px;
  box-sizing: border-box;
`;

const bounce = keyframes`
  0%, 20%, 40%, 60%, 80%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
`;

export const CircleNotificationPending = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255, 90, 95);
  position: absolute;
  height: ${props => (props?.height ? props.height : 0)};
  width: ${props => (props?.width ? props.width : 0)};
  margin-top: ${props => (props?.mt ? props.mt : 0)};
  margin-left: ${props => (props?.ml ? props.ml : 0)};
  margin-right: ${props => (props?.mr ? props.mr : 0)};
  border-radius: ${props => (props?.borderRadius ? props.borderRadius : 0)};
  animation: ${bounce} 1.5s linear infinite;

  & > div {
    justify-content: center;
    line-height: 18px;
    color: #fff;
  }
`;
